import React from "react";
import Link from "next/link";
import { StickynavTargetDefense } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData } from "@storyblok/react";

interface StickySubnavProps {
  blok: StickynavTargetDefense & SbBlokData;
}

const StickySubnav: React.FC<StickySubnavProps> = ({ blok }) => {
  if (!blok) return null;

  const { navigation_sections, phone_number, cta_buttons } = blok;

  return (
    <div className="sticky-subnav">
      <div className="subheader">
        <div className="container">
          {/* Left Subnav Section */}
          <div className="subheader-left">
            {navigation_sections && (
              <ul className="subnav">
                {navigation_sections.map((link) => (
                  <li key={link._uid}>
                    <Link
                      href={link.link?.cached_url || "#"}
                      target={link.external ? "_blank" : "_self"}
                    >
                      {link.text || "Unnamed Link"}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="subheader-right">
            {phone_number && (
              <Link
                href={`tel:${phone_number.replace(/\D/g, "")}`}
                className="subheader-phone-number"
                aria-label={`Call us at ${phone_number.trim()}`}
              >
                {phone_number}
              </Link>
            )}
            {cta_buttons?.map((button) => (
              <Link
                key={button._uid}
                href={button.link?.cached_url || "#"}
                className={`button button-small subheader-button ${
                  button.js ? "js-cta-button" : ""
                }`}
              >
                Get a quote
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickySubnav;